import React from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';

import s from './deliveryFormTitle.scss';

type PropsType = {
    className?: string;
    isRequired?: boolean;
    children: React.ReactNode;
};

/**
 * Delivery form title for checkout
 *
 * @constructor
 */
export const DeliveryFormTitle: React.FC<PropsType> = ({
    children,
    className = '',
    isRequired = false,
}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <h2 className={classNames(s.title, {[s.titleFacelift]: isFacelift}, className)}>
            {children} {isRequired && <span className={s.required}>* Required Fields</span>}
        </h2>
    );
};
